// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__naq4T","colBig":"styles_colBig__3AUhh","colSmall":"styles_colSmall__3bS2U"};